import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class dmRoomType {
    RoomType:   RQService.Pms.GetRoomTypesRow;

    IsSelected: boolean;

    constructor(
        pRoomType: RQService.Pms.GetRoomTypesRow
    ) {
        this.RoomType   = pRoomType;
        this.IsSelected = false;
    }
}

export class AvailabilityViewModel {
    ShowAlert: (pTitle: string, pMessage: string) => void;
    BackToSignIn: () => void;
    NewLoading: (pMessage: string) => dmLoading;
    DetectWidth: () => number;
    RegisterResize: (pAction: () => void) => void;
    ShowCalendar: (
        pToday: Date
        , pCDay: Date
        , pTitle: string
        , pLangID: number
        , pAction: (pCDay: Date) => void
    ) => void;

    mlText: MLText;
    app: mlBroker;
    ml: mlBroker;
    Hotel: dmHotel;
    LangID: number;

    InRefresh: boolean;
    NumDaysAll: number;
    NumDays: number;

    InAction: boolean;
    HasCacheData: boolean;

    AvailabilityDays: RQService.Pms.GetAvailabilityPeriodRow[];
    DisplayDays: RQService.Pms.GetAvailabilityPeriodRow[];

    SelectedRoomTypeID: number;
    SelectedRoomTypeName: string;
    Today: Date;
    StartDate: Date;
    EndDate: Date;
    EndPeriodDate: Date;

    StartDateDisplay: string;
    EndPeriodDisplay: string;

    StartDateModified: boolean;
    CalHasTwoMonths: boolean;
    FirstMonthLabel: string;
    SecondMonthLabel: string;

    RoomTypes: dmRoomType[];
    RoomTypesByID: dmRoomType[];

    AvailabilityPeriod: string;
    options: boolean; // showing day by day or period base

    constructor(
        pMLText: MLText
        , pHotel: dmHotel
        , pBackToSignIn: () => void
        , pShowAlert: (pTitle: string, pMessage: string) => void
        , pNewLoading: (pMessage: string) => dmLoading
        , pDetectWidth: () => number
        , pRegisterResize: (pAction: () => void) => void
        , pShowCalendar: (
            pToday: Date
            , pCDay: Date
            , pTitle: string
            , pLangID: number
            , pAction: (pCDay: Date) => void
        ) => void
    ) {
        this.mlText = pMLText;
        this.LangID = this.mlText.GetLangID();
        this.app = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml = this.mlText.GetBroker(
            'HotelAreaAvailability'
        );

        this.Hotel = pHotel;
        this.BackToSignIn = pBackToSignIn;
        this.ShowAlert = pShowAlert;
        this.NewLoading = pNewLoading;
        this.DetectWidth = pDetectWidth;
        this.RegisterResize = pRegisterResize;
        this.ShowCalendar = pShowCalendar;

        this.InRefresh = false;
        this.NumDaysAll = 30;

        this.InAction = true;
        this.HasCacheData = true;
        this.AvailabilityPeriod = '';

        this.SelectedRoomTypeID = 0;

        this.RoomTypes = [];
        this.RoomTypesByID = [];
        this.AvailabilityDays = [];
        this.DisplayDays = [];

        this.options = true;

        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        this.NumDays = this.numDaysFromWidth(this.DetectWidth());

        this.RegisterResize(() => {
            this.refreshNumDays(this.numDaysFromWidth(this.DetectWidth()));
        });

        loading.Show(() => {
            this.refreshRoomTypes(() => {
                loading.Dismiss();

                this.InAction = false;
            });
        });
    }

    private numDaysFromWidth(pWidth: number): number {
        let numDays: number = 0;

        if (pWidth < 768) {
            numDays = Math.floor((pWidth - 130) / 50);
        } else {
            numDays = Math.floor((pWidth - 440) / 50);
        }

        if (numDays < 4) { numDays = 4; }
        if (numDays > 30) { numDays = 30; }

        return numDays;
    }

    private refreshNumDays(pNumDays: number): void {
        this.NumDays = pNumDays;

        if (this.NumDays > 30) { this.NumDays = 30 }

        this.DisplayDays.length = 0;

        if (this.SelectedRoomTypeID == 0) {
            this.updateDateDisplay();

            return;
        }

        let date_idx: Date = new Date(
            this.StartDate.getFullYear()
            , this.StartDate.getMonth()
            , this.StartDate.getDate()
        );

        for (let i = 0; i < this.NumDays; i++) {
            let day: RQService.Pms.GetAvailabilityPeriodRow = null;
            let dayInCache: boolean = false;

            for (let i = 0; i < this.AvailabilityDays.length; i++) {
                let resDay: Date = new Date(
                    Number(this.AvailabilityDays[i].ResDay.substr(0, 4))
                    , Number(this.AvailabilityDays[i].ResDay.substr(5, 2)) - 1
                    , Number(this.AvailabilityDays[i].ResDay.substr(8, 2))
                );

                if (resDay.valueOf() == date_idx.valueOf()) {
                    day = this.AvailabilityDays[i]
                    dayInCache = true;

                    break;
                }
            }

            if (!dayInCache) {
                day = RQService.Pms.PopulateGetAvailabilityPeriodRow({});

                this.initNonCacheDay(day, date_idx);
            }

            this.DisplayDays.push(day);

            date_idx.setDate(date_idx.getDate() + 1);
        }

        this.updateDateDisplay();
    }

    private initNonCacheDay(
        pNonCacheDay: RQService.Pms.GetAvailabilityPeriodRow
        , pResDay: Date
    ): void {
        pNonCacheDay.ResDay = RQApp.JSDateToRQString(pResDay, false);
        pNonCacheDay.Availability = 0;
    }

    private refreshRoomTypes(pAction: () => void) {
        if (this.InRefresh) { return; }

        this.updateNotionOfToday();

        this.updateDateDisplay();

        let roomTypesParams = RQParam.PmsGetRoomTypesParams();

        roomTypesParams.HotelID = this.Hotel.HotelID;
        roomTypesParams.LangID = this.LangID;

        RQService.Pms.GetRoomTypes(roomTypesParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { return; }

            let roomTypes = response.RQueryResult;

            for (let i = 0; i < roomTypes.length; i++) {
                let roomType = new dmRoomType(
                    RQService.Pms.PopulateGetRoomTypesRow(
                        roomTypes[i]
                    )
                );
                this.RoomTypes.push(roomType);

                this.RoomTypesByID[roomType.RoomType.RoomTypeID] = roomType;
            }

            pAction();
        });
    }

    public SelectRoomType(event: any) {
        let roomTypeID = event as number;
        this.SelectedRoomTypeID = roomTypeID;

        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshAvailabilityDays(() => { loading.Dismiss(); });
        });
    }

    private refreshAvailabilityDays(pAction: () => void): void {
        if (this.InRefresh) { return; }

        let availabilityParams = RQParam.PmsGetAvailabilityPeriodParams();
        let endDate = new Date(this.StartDate);

        endDate.setDate(this.StartDate.getDate() + (this.NumDaysAll - 1));

        availabilityParams.HotelID = this.Hotel.HotelID;
        availabilityParams.RoomTypeID = this.SelectedRoomTypeID;
        availabilityParams.StartDate = RQApp.JSDateToRQString(this.StartDate, false);
        availabilityParams.EndDate = RQApp.JSDateToRQString(endDate, false);

        RQService.Pms.GetAvailabilityPeriod(availabilityParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { pAction(); return; }

            let days = response.RQueryResult;

            this.AvailabilityDays.length = 0;

            for (let i = 0; i < days.length; i++) {
                let day = RQService.Pms.PopulateGetAvailabilityPeriodRow(
                    days[i]
                );

                console.log('av row push');

                this.AvailabilityDays.push(day);
            }

            this.DisplayDays.length = 0;

            if (this.SelectedRoomTypeID == 0) {
                this.updateDateDisplay();

                pAction();

                return;
            }

            let date_idx: Date = new Date(
                this.StartDate.getFullYear()
                , this.StartDate.getMonth()
                , this.StartDate.getDate()
            );

            for (let i = 0; i < this.NumDays; i++) {
                let day: RQService.Pms.GetAvailabilityPeriodRow = null;
                let dayInCache: boolean = false;

                for (let i = 0; i < this.AvailabilityDays.length; i++) {
                    let resDay: Date = new Date(
                        Number(this.AvailabilityDays[i].ResDay.substr(0, 4))
                        , Number(this.AvailabilityDays[i].ResDay.substr(5, 2)) - 1
                        , Number(this.AvailabilityDays[i].ResDay.substr(8, 2))
                    );

                    if (resDay.valueOf() == date_idx.valueOf()) {
                        day = this.AvailabilityDays[i]
                        dayInCache = true;

                        break;
                    }
                }

                if (!dayInCache) {
                    day = RQService.Pms.PopulateGetAvailabilityPeriodRow({});

                    this.initNonCacheDay(day, date_idx);
                }

                this.DisplayDays.push(day);

                date_idx.setDate(date_idx.getDate() + 1);
            }

            pAction();
        });
    }

    public SaveDayAvailability(
        AType: number,
        pResDay: string,
        pAvailability: number
    ): void {
        if (this.InRefresh) { return; }

        if (!pAvailability) { pAvailability = 0; }
        if (pAvailability < 0) { pAvailability = 0; }

        pAvailability = Math.floor(pAvailability);

        let blockParams = RQParam.PmsAcceptAvUpdateDaysViaManualEntryParams();

        blockParams.HotelID = this.Hotel.HotelID;
        blockParams.LangID = this.LangID;

        if (AType == 1) {

            blockParams.StartDate = this.StartDateDisplay;
            blockParams.EndDate = this.EndPeriodDisplay;
            console.log("period save blockParams.StartDate:" + blockParams.StartDate + " blockParams.EndDat:" + blockParams.EndDate);
        } else {
            blockParams.StartDate = pResDay;
            blockParams.EndDate = pResDay;
        }

        blockParams.RoomTypeID = this.SelectedRoomTypeID;
        blockParams.Availability = pAvailability;


        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            RQService.Pms.AcceptAvUpdateDaysViaManualEntry(blockParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                this.refreshAvailabilityDays(() => { loading.Dismiss(); });
            });
        });
    }

    public ChangeCalDate(pStartDate: Date): void {
        if (this.InRefresh) { return; }
        if (this.StartDate.getTime() === pStartDate.getTime()) { return; }

        this.StartDateModified = true;

        this.StartDate = pStartDate;

        this.EndDate = new Date(
            pStartDate.getFullYear()
            , pStartDate.getMonth()
            , pStartDate.getDate()
        );

        this.EndDate.setDate(this.EndDate.getDate() + (this.NumDaysAll - 1));
        this.updateDateDisplay();
        let loading: dmLoading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshAvailabilityDays(() => {
                loading.Dismiss();

                return;
            });
        });
    }

    private updateNotionOfToday(): void {
        let now = new Date();

        this.Today = new Date(
            now.getFullYear()
            , now.getMonth()
            , now.getDate()
        );

        if (!this.StartDateModified) {
            this.StartDate = new Date(
                this.Today.getFullYear()
                , this.Today.getMonth()
                , this.Today.getDate()
            );

            this.StartDateDisplay = RQApp.JSDateToRQString(this.StartDate, false);
        }
    }

    private updateDateDisplay() {
        this.StartDateDisplay = RQApp.JSDateToRQString(this.StartDate, false);

        this.FirstMonthLabel = this.StartDate.toLocaleString(
            RQApp.LangCodesByID[this.LangID]
            , { month: 'long' }
        ) + ' ' + this.StartDate.getFullYear().toString();

        let endDate: Date = new Date(
            this.StartDate.getFullYear()
            , this.StartDate.getMonth()
            , this.StartDate.getDate()
        );

        endDate.setDate(endDate.getDate() + (this.NumDays - 1));

        if (this.StartDate.getMonth() == endDate.getMonth()) {
            this.CalHasTwoMonths = false;
            this.SecondMonthLabel = '';
        } else {
            this.CalHasTwoMonths = true;
            this.SecondMonthLabel = endDate.toLocaleString(
                RQApp.LangCodesByID[this.LangID]
                , { month: 'long' }
            ) + ' ' + this.StartDate.getFullYear().toString();
        }

        this.EndDate = endDate;
        this.EndPeriodDate = endDate;
        this.EndPeriodDisplay = RQApp.JSDateToRQString(this.EndDate, false);
    }

    public ShowDateSelector(): void {
        if (this.InRefresh) { return; }

        this.updateNotionOfToday();

        this.ShowCalendar(
            this.Today
            , this.StartDate
            , this.ml.Text('ChooseStartDay', 'Choose Start Day')
            , this.LangID
            , (pStartDate: Date) => { this.ChangeCalDate(pStartDate); }
        );
    }

    public CalDateNext() {
        if (this.InRefresh) { return; }

        this.StartDateModified = true;

        this.StartDate.setDate(this.StartDate.getDate() + (this.NumDays - 1));
        this.EndDate.setDate(this.EndDate.getDate() + (this.NumDays - 1));

        this.updateDateDisplay();

        let loading: dmLoading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshAvailabilityDays(() => {
                loading.Dismiss();

                return;
            });
        });
    }

    public CalDatePrev() {
        if (this.InRefresh) { return; }

        this.StartDateModified = true;

        this.StartDate.setDate(this.StartDate.getDate() - (this.NumDays - 1));
        this.EndDate.setDate(this.EndDate.getDate() - (this.NumDays - 1));

        if (this.StartDate < this.Today) {
            this.StartDate = new Date(
                this.Today.getFullYear()
                , this.Today.getMonth()
                , this.Today.getDate()
            );

            this.EndDate.setDate(this.Today.getDate() + (this.NumDays - 1));
        }

        this.updateDateDisplay();

        let loading: dmLoading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshAvailabilityDays(() => {
                loading.Dismiss();

                return;
            });
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }

    // Period-Window-Part
    public ShowPeriodBeginSelector(): void {
        if (this.InRefresh) { return; }

        console.log("ShowPeriodBeginSelector  this.StartDate:" + this.StartDate);

        this.ShowCalendar(
            this.Today
            , this.StartDate
            , this.ml.Text('ChooseStartDay', 'Choose Start Day')
            , this.LangID
            , (pEndDate: Date) => { this.ChangeCalBeginPeriod(pEndDate); }
        );

        console.log("ShowPeriodBeginSelector ");
    }

    public ShowPeriodEndSelector(): void {
        if (this.InRefresh) { return; }

        console.log("ShowDateEndSelector EndPeriodDate:" + this.EndPeriodDate);

        this.ShowCalendar(
            this.Today
            , this.EndPeriodDate
            , this.ml.Text('ChoosePeriodEnd', 'Choose Period End')
            , this.LangID
            , (pEndDate: Date) => { this.ChangeCalEndPeriod(pEndDate); }
        );

        console.log("ShowPeriodEndSelector pEndDate:");
    }

    public ChangeCalBeginPeriod(pStartDate: Date): void {
        if (this.InRefresh) { return; }
        if (this.StartDate.getTime() === pStartDate.getTime()) { return; }

        this.StartDateModified = true;

        this.StartDate = pStartDate;
        let selStartDate: Date = this.StartDate;


        if (this.StartDate > this.EndPeriodDate) {
            this.EndPeriodDate = new Date(
                this.StartDate.getFullYear()
                , this.StartDate.getMonth()
                , this.StartDate.getDate()
            );
            this.EndPeriodDisplay = RQApp.JSDateToRQString(this.EndPeriodDate, false);
            console.log('stardate > endperioddate');
        } else {
            console.log('stardate < endperioddate');
        }

        this.StartDateDisplay = RQApp.JSDateToRQString(this.StartDate, false);

        let loading: dmLoading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshAvailabilityDays(() => {
                loading.Dismiss();

                return;
            });
        });
    }

    public ChangeCalEndPeriod(pEndDate: Date): void {
        console.log("ChangeCalEndPeriod  pEndDate:" + pEndDate);
        if (this.InRefresh) { return; }

        this.EndPeriodDate = new Date(
            pEndDate.getFullYear()
            , pEndDate.getMonth()
            , pEndDate.getDate()
        );


        if (this.EndPeriodDate < this.StartDate) {
            this.StartDate = new Date(
                this.EndPeriodDate.getFullYear()
                , this.EndPeriodDate.getMonth()
                , this.EndPeriodDate.getDate()
            );
            this.StartDateDisplay = RQApp.JSDateToRQString(this.StartDate, false);

            console.log('EndPeriodDate < StartDate');
        } else {
            console.log('EndPeriodDate > StartDate');
        }
        this.EndPeriodDisplay = RQApp.JSDateToRQString(this.EndPeriodDate, false);

        console.log("selected enddate:" + this.EndPeriodDate);

        if (this.SelectedRoomTypeID > 0) {
            let loading: dmLoading = this.NewLoading(
                this.app.Text('LoadingMark', 'Loading...')
            );

            loading.Show(() => {
                this.refreshAvailabilityDays(() => {
                    loading.Dismiss();

                    return;
                });
            });
        }
    }

    public SavePeriod() {
        console.log('avp ' + this.AvailabilityPeriod);

        if (
            this.AvailabilityPeriod        === ''
        ||  this.AvailabilityPeriod.trim() === ''
        ) { this.AvailabilityPeriod = ''; return; }

        if (isNaN(Number(this.AvailabilityPeriod))) { this.AvailabilityPeriod = ''; return; }

        let availability: number = Number(this.AvailabilityPeriod);

        if (!availability)    { availability = 0; }
        if (availability < 0) { availability = 0; }

        availability = Math.floor(availability);

        if (this.SelectedRoomTypeID == 0) {
            this.ShowAlert(
                this.ml.Text(
                     'SelectRoomType'
                    ,'Select A RoomType'
                )
                ,this.ml.Text(
                     'SelectRoomType'
                    ,'Select A RoomType'
                )
            );

            return;
        }

        this.SaveDayAvailability(1, '', availability);
    }
}


// WEBPACK FOOTER //
// ./src/pages/availability/xv-availability.ts